export default {
  /* Load charts from LocalStorage */
  AWS_LOAD_CHARTS: 'AWS_LOAD_CHARTS',
  AWS_LOAD_CHARTS_ERROR: 'AWS_LOAD_CHARTS_ERROR',
  AWS_INSERT_CHARTS: 'AWS_INSERT_CHARTS',
  AWS_INSERT_COSTS_DATES: 'AWS_INSERT_COSTS_DATES',
  AWS_INSERT_COSTS_INTERVAL: 'AWS_INSERT_COSTS_INTERVAL',
  AWS_INSERT_COSTS_FILTER: 'AWS_INSERT_COSTS_FILTER',

  /* Clear LocalStorage */
  AWS_CLEAR_CHARTS: 'AWS_CLEAR_CHARTS',

  /* Charts initialization */
  AWS_INIT_CHARTS: 'AWS_INIT_CHARTS',
  AWS_INIT_CHARTS_ERROR: 'AWS_INIT_CHARTS_ERROR',

  /* Multi charts support */
  AWS_ADD_CHART: 'AWS_ADD_CHART',
  AWS_REMOVE_CHART: 'AWS_REMOVE_CHART',

  /* Costs values */
  AWS_GET_COSTS: 'AWS_GET_COSTS',
  AWS_GET_COSTS_SUCCESS: 'AWS_GET_COSTS_SUCCESS',
  AWS_GET_COSTS_ERROR: 'AWS_GET_COSTS_ERROR',

  /* Dates */
  AWS_SET_COSTS_DATES: 'AWS_SET_COSTS_DATES',
  AWS_RESET_COSTS_DATES: 'AWS_RESET_COSTS_DATES',
  AWS_CLEAR_COSTS_DATES: 'AWS_CLEAR_COSTS_DATES',

  /* Intervals */
  AWS_SET_COSTS_INTERVAL: 'AWS_SET_COSTS_INTERVAL',
  AWS_RESET_COSTS_INTERVAL: 'AWS_RESET_COSTS_INTERVAL',
  AWS_CLEAR_COSTS_INTERVAL: 'AWS_CLEAR_COSTS_INTERVAL',

  /* Filters */
  AWS_SET_COSTS_FILTER: 'AWS_SET_COSTS_FILTER',
  AWS_RESET_COSTS_FILTER: 'AWS_RESET_COSTS_FILTER',
  AWS_CLEAR_COSTS_FILTER: 'AWS_CLEAR_COSTS_FILTER'
};



// WEBPACK FOOTER //
// ./src/constants/aws/costsTypes.js